import isEmail from 'validator/lib/isEmail';
import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const schema = {
	'newDefaultPrintDocumentRecipientEmail': (value, state) => {
		if (!value) {
			// allow empty value
			return false;
		} if (state.touched['newDefaultPrintDocumentRecipientEmail'] && !isEmail(value)) {
			return localize('customize-default-print-document-recipient-email-invalid');
		}		
	},
};

export default schema;


// WEBPACK FOOTER //
// ./src/containers/Customize/CustomizeSchema.js